export function getDaysCountText(count: number): string {
  let text = '';
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (!count) return text;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    text = 'дней';
  } else if (lastDigit === 1) {
    text = 'день';
  } else if (lastDigit > 1 && lastDigit < 5) {
    text = 'дня';
  } else text = 'дней';

  return count + ' ' + text;
}
